export enum PDFViewerViewMode {
  DOCUMENT = 'DOCUMENT',
  THUMBNAIL = 'THUMBNAIL',
}

export interface PDFViewerProps {
  src?: string;
  base64Content?: string;
  allowPageSelection?: boolean;
  selectedPages?: Set<number>;
  onPageToggle?: (pageNumber: number) => void;
  viewMode: PDFViewerViewMode;
}